export enum ButtonTheme {
  Mango = "from-mango to-crail",
  PersianPink = "from-persian-pink to-cadillac",
  Bermuda = "from-bermuda to-ming",
}
